<template>
  <div class='NaveIcon'>
    <svg :width="tam" :height="tam" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_429_11066)">
        <path d="M3 6.00092H21M3 12.0009H21M3 18.0009H21" :stroke="color" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_429_11066">
        <rect width="24" height="24" fill="white" transform="translate(0 0.000915527)"/>
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'NaveIcon',
  props: {
    tam: {
      type: String,
      default: '30px'
    },
    color: {
      type: String,
      default: '#000000'
    }
  }
}
</script>
